import { useCallback, useState } from 'react';

export type UseScreener = () => {
  responses: (string | undefined)[];

  submitResponse: (questionId: number, response: string) => void;
};

export const useScreenerResponses: UseScreener = () => {
  const [responses, setResponses] = useState<(string | undefined)[]>([]);

  const submitResponse = useCallback((questionId: number, response: string) => {
    setResponses(r => {
      const newValue = [...r];
      newValue[questionId] = response;
      return newValue;
    });
  }, []);

  return {
    responses,
    submitResponse,
  };
};
